import React, { useState } from 'react';
import { Form, OverlayTrigger, Popover } from 'react-bootstrap';

import DatePicker, { registerLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import InputMask from 'react-input-mask';

import { stringToDate } from '../../utils/formatador';
import { dateToString } from '../../utils/formatador';

registerLocale(ptBR);

export default function InputDate({ 
    id, name, value, 
    onChange, onDate, 
    className,

    minDate, maxDate,
    placement = "auto",
    filterDate,
    overlayTrigger = ["click"],

    ...rest
}) {
    
    const [dateString, setDateString] = useState(dateToString(value));

    function handleChange(e) {
        const { value } = e.target;
        setDateString(value);
        const dateValue = stringToDate(value);
        
        if(dateValue) {
            if(onChange) onChange({ id, target: { id, name, value: dateValue }});
            if(onDate) onDate(dateValue, e);
        } else {
            if(onChange) onChange({ id, target: { id, name, value: undefined }});
            if(onDate) onDate(undefined, e);
        }
    }

    function handleDatePick(date) {
        //Clear hours of date
        date = new Date(date);
        date.setHours(12);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);

        setDateString(dateToString(date));

        if(onChange) onChange({ target: { id, name, value: date }});
        if(onDate) onDate(date, null);
    }
    
    return (
        <OverlayTrigger rootClose trigger={overlayTrigger} placement="auto"
            overlay={
                <Popover>
                    <Popover.Content className="p-0">
                        <DatePicker selected={value} className="border-0" inline dateFormat="dd/MM/yyyy" locale="pt-BR" showYearDropdown 
                            onChange={handleDatePick} filterDate={filterDate}
                            minDate={minDate} maxDate={maxDate}   
                        />
                    </Popover.Content>
                </Popover>
            }
        >
            <Form.Control as={InputMask} value={dateString} className={`form-control ${className}`} 
                mask="99/99/9999" pattern="[0-9]"
                onChange={handleChange}
                {...rest}
            />
        </OverlayTrigger>
    )
}